import { RouteOutlined } from "@mui/icons-material";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import RoutesPlannedTab from "./RoutesPlannedTab";
import RoutesSimpleTab from "./RoutesSimpleTab";
import RoutesReportTab from "./RoutesReportTab";

const RoutesPage = ({ isHiddenMenu, allowCalculatedRoutes = true }: { isHiddenMenu: boolean; allowCalculatedRoutes?: boolean }) => {
    const [tab, setTab] = useState(0);

    useEffect(() => {
        if (!allowCalculatedRoutes && tab !== 0) setTab(0);
    }, [allowCalculatedRoutes, tab]);

    return (
        <Box className="grid-box-out-container tw-flex tw-min-h-screen tw-w-full tw-min-w-0 tw-items-start tw-justify-center tw-bg-transparent tw-px-2 tw-pb-4 tw-font-prometo sm:tw-px-3" sx={{ pt: { xs: 2, sm: "max(28px, calc((100dvh - 790px) / 2))" } }}>
            <Box className="grid-container container container-fluid tw-flex tw-min-h-0 tw-min-w-0 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-bg-gtr-surface tw-p-2.5 sm:tw-p-3" sx={{ width: { xs: "100%", md: isHiddenMenu ? "70vw" : "65vw" }, maxWidth: 1280, height: { xs: "calc(100dvh - 32px)", sm: "min(790px, calc(100dvh - 56px))" } }}>
                <Box className="grid-header-bar tw-flex tw-min-h-14 tw-flex-none tw-items-center tw-gap-3 tw-rounded-lg tw-bg-gtr-sidebar tw-px-4 tw-py-3 tw-text-white">
                    <RouteOutlined aria-hidden="true" />
                    <Typography variant="h6" className="!tw-font-prometo !tw-text-lg !tw-font-bold !tw-text-white">Rotas</Typography>
                </Box>
                <Tabs
                    value={tab}
                    onChange={(_, value) => setTab(value)}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    className="tw-mt-2 tw-flex-none tw-rounded-lg tw-bg-gtr-surface-muted"
                    sx={{
                        minHeight: 48,
                        "& .MuiTab-root": { minHeight: 48, fontFamily: "Prometo", textTransform: "none", fontWeight: 700, color: "text.secondary" },
                        "& .Mui-selected": { color: "#00B700 !important" },
                        "& .MuiTabs-indicator": { height: 3, borderRadius: 3, bgcolor: "#00B700" },
                    }}
                >
                    <Tab label="Rota simples" />
                    {allowCalculatedRoutes && <Tab label="Rotas previstas" />}
                    {allowCalculatedRoutes && <Tab label="Rotas previstas x rotas realizadas" />}
                </Tabs>
                <Box className="tw-min-h-0 tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-pt-2">
                    {tab === 0 || !allowCalculatedRoutes ? <RoutesSimpleTab /> : tab === 1 ? <RoutesPlannedTab isHiddenMenu={isHiddenMenu} /> : <RoutesReportTab />}
                </Box>
            </Box>
        </Box>
    );
};

export default RoutesPage;
